import useApiHook from './useApiHook';
import { useCallback } from 'react';

export const useUsersEnum = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getUsersEnum = useCallback(
    async (role) => {
      const output = await get('/enums/users');
      const data = output.data?.filter((line) => line.role === role);
      if (data != null) {
        return data?.map((line) => {
          return {
            id: line.id,
            label: `${line.surname}, ${line.firstname}`,
          };
        });
      } else {
        return null;
      }
    },
    [get],
  );

  return { getUsersEnum, data, error, loading };
};
